<template>
  <div class="container px-2 flex flex-1 flex-wrap lg:flex-nowrap mx-auto">
    <ul class="nav-content list-none relative grid w-full md:w-1/2 lg:mb-0 lg:w-auto pt-5 pb-2 lg:pb-5" role="menu">
      <li v-for="item of visibleLinks" :key="item.uid" role="none">
        <a
          ref="link"
          :href="composeLink(item.url)"
          :target="setTarget(item.target)"
          role="menuitem"
          class="block leading-[40px] text-sm font-medium nav__menu-item hover:underline"
          :qaid="item.uid"
          tabindex="-1"
          @keydown.prevent.right="focusNextColumn"
          @keydown.prevent.left="
            (e) => {
              !isCompactView ? focusPreviousColumn(e) : focusParentTier();
            }
          "
          @keydown.prevent.down="focusNextElement"
          @keydown.prevent.up="focusPreviousElement"
        >
          <span class="flex items-center gap-1 pointer-events-none relative">
            <span v-html="item.linkName"></span>
          </span>
        </a>
      </li>
    </ul>
    <ul v-if="visibleEditorialCards" class="list-none py-2 lg:pt-5 lg:mb-0 w-full md:w-1/2 lg:w-fit">
      <li
        v-for="item of visibleEditorialCards"
        :key="item.ctaLinks.uid"
        class="nav-default-editorial-cards inline-grid mb-2 mr-2"
      >
        <NavCard
          :card="item"
          :down-function="focusNextElement"
          :up-function="
            (e) => {
              isCompactView ? focusPreviousElement(e) : focusParentTier();
            }
          "
          :right-function="focusNextElement"
          :left-function="
            (e) => {
              !isCompactView ? focusPreviousElement(e) : focusParentTier();
            }
          "
        />
      </li>
    </ul>
  </div>
</template>

<script>
import NavCard from '@/navigation/components/NavCard.vue';
import {mapState} from 'vuex';
import links from '@/navigation/mixins/links.js';
export default {
  name: 'NavDefaultLayout',
  components: {
    NavCard,
  },
  mixins: [links],
  inject: ['focusParentTier', 'focusNextMenuItem', 'isElectra', 'focusPreviousMenuItem'],
  props: {
    navItemData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState('global', ['isCompactView']),
    visibleLinks() {
      return (
        this.navItemData?.links?.filter((item) => item?.hasVisibleProducts !== false && item?.visible !== false) || []
      );
    },
    visibleEditorialCards() {
      return (
        this.navItemData?.categoryCardEditorialComponentData?.filter(
          (item) => item.ctaLinks?.[0]?.hasVisibleProducts !== false && item.ctaLinks?.[0]?.visible !== false
        ) || []
      );
    },
  },
  methods: {
    focusPreviousColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.previousElementSibling
        ? e.target.parentNode.parentNode.previousElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.lastElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },
    focusNextColumn(e) {
      const newFocusedItem = e.target.parentNode.parentNode.nextElementSibling
        ? e.target.parentNode.parentNode.nextElementSibling?.querySelector('.nav__menu-item')
        : e.target.parentNode.parentNode.parentNode.firstElementChild.querySelector('.nav__menu-item');
      e.target.tabIndex = -1;
      newFocusedItem.focus();
    },

    focusNextElement(e) {
      const elIndex = this.$refs.link.indexOf(e.target);
      e.target.tabIndex = -1;
      const targetIndex = elIndex < this.$refs.link.length - 1 ? elIndex + 1 : 0;
      this.$refs.link[targetIndex].tabIndex = 0;
      this.$refs.link[targetIndex].focus();
    },
    focusPreviousElement(e) {
      const elIndex = this.$refs.link.indexOf(e.target);
      if (elIndex === 0 && !this.isCompactView) {
        this.focusParentTier(e);
        return;
      }
      e.target.tabIndex = -1;
      const targetIndex = elIndex > 0 ? elIndex - 1 : this.$refs.link.length - 1;
      this.$refs.link[targetIndex].tabIndex = 0;
      this.$refs.link[targetIndex].focus();
    },
  },
};
</script>
<style lang="scss">
.nav-content {
  grid-auto-rows: 40px;

  @media (screen(lg)) {
    grid-template-rows: repeat(auto-fit, 40px);
    grid-auto-flow: column;
    grid-template-columns: calc(var(--nav-container) / 3 - 1rem);
    max-height: calc(85vh - var(--nav-tier-1-height, 0px) - var(--header-height));
    min-height: calc(400px + 5rem);

    > li {
      width: calc(var(--nav-container) / 3 - 1rem);
    }
  }
}

.nav-default-editorial-cards .nav-marketing-card.w-full {
  width: calc((var(--nav-container) / 3) - (2rem));
}
</style>
